// extracted by mini-css-extract-plugin
module.exports = {"textarea":"textarea__Fw9d4nDylK30G","red":"red__yQr9Ud40vdVad"};